import {useRouteError} from 'react-router-dom';
import {ErrorFallback} from '@app/ErrorFallback';

/**
 * `errorElement` корневого маршрута: показывает ошибку страницы нашим экраном
 * вместо стандартного «Unexpected Application Error! / Hey developer».
 */
export const RouteErrorPage = () => <ErrorFallback error={useRouteError()} />;
